export default () => {
  const section = document.querySelector('.downloads');

  if(!section) return;

  const list = document.querySelector('.downloads__list');
  const items = [...document.querySelectorAll('.downloads__item')];

  if(items.length > 5) {
    list.style.maxWidth = '684px';
  }
}